import { MessageService } from '../../messageService';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/reducers/snackbar';

export const Messages = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const subscription = MessageService.onShowMessage().subscribe((msg) => {
      dispatch(
        openSnackbar({
          open: true,
          message: msg.message,
          variant: 'alert',
          alert: {
            color: msg.type.toString()
          },
          close: true
        })
      );
    });
    return () => subscription.unsubscribe();
  }, [dispatch]);

  return <></>;
};
